import Vue from 'vue';
import VueRouter from 'vue-router';

const PageIndex = () => import('../component/page/Index.vue');
// const PageFeature = () => import('../component/page/Feature.vue');
const PageRegister = () => import('../component/page/member/Register.vue');
// const PageSelectTag = () => import('../component/page/member/SelectTag.vue');
// const PageSearchResult = () => import('../component/page/search/Result.vue');
const PageSetting = () => import('../component/page/account/Setting.vue');
const PageEcard = () => import('../component/page/account/Ecard.vue');
// const PageProfile = () => import('../component/page/member/Profile.vue');
// const PageProfileDetail = () => import('../component/page/member/ProfileDetail.vue');
// const PageProfileBookmark = () => import('../component/page/member/ProfileBookmark.vue');
// const PageProfileResume = () => import('../component/page/member/ProfileResume.vue');
// const PageProfileFollower = () => import('../component/page/member/ProfileFollower.vue');
// const PageProfileFollowing = () => import('../component/page/member/ProfileFollowing.vue');
// const PageQaDetail = () => import('../component/page/qa/Question.vue');
// const PageScoopDetail = () => import('../component/page/scoop/Scoop.vue');
// const PageTeamDetail = () => import('../component/page/team/Team.vue');
const PageCourseMenu = () => import('../component/page/course/CourseMenu.vue');
const PageCourse = () => import('../component/page/course/Course.vue');
const PageFooterAbout = () => import('../component/page/footer/About.vue');
// const PageFooterTutorial = () => import('../component/page/footer/Tutorial.vue');
const PageFooterPrivacy = () => import('../component/page/footer/Privacy.vue');
const PageFooterTermUsage = () => import('../component/page/footer/TermUsage.vue');
const PageEvent = () => import('../component/page/event/Event.vue');
const PageEventBlock = () => import('../component/page/event/EventMain.vue');
// const PageHelp = () => import('../component/page/search/Help.vue');
const PageSideEffect = () => import('../component/page/sideeffect/Effect.vue');
// const PageSideEffectDemo = () => import('../component/page/sideeffect/EffectDemo.vue');
const PageSideEffectSetup = () => import('../component/page/sideeffect/EffectSetup.vue');
const PageSideEffectBoard = () => import('../component/page/sideeffect/EffectBoard.vue');
const PageSideEffectRecord = () => import('../component/page/sideeffect/EffectRecord.vue');
// const PageSideEffectAiDoctor = () => import('../component/page/sideeffect/EffectAiDoctor.vue');
// const PageSideEffectRecordDetail = () => import('../component/page/sideeffect/EffectUserRecordDetail.vue');
const PageSideEffectConsult = () => import('../component/page/sideeffect/EffectConsult.vue');
const PageSideEffectDiet = () => import('../component/page/sideeffect/EffectDiet.vue');
const PageSideChronicBlood = () => import('../component/page/sideeffect/ChronicBlood.vue');
const PageSideEffectPost = () => import('../component/page/sideeffect/EffectPost.vue');
const PageSideEffectPostGenerator = () => import('../component/page/sideeffect/EffectPostGenerator.vue');
// const PageSideEffectProfile = () => import('../component/page/sideeffect/EffectProfile.vue');
const PageSideEffectTranslator = () => import('../component/page/sideeffect/EffectTranslator.vue');
// const PageSideEffectSummary = () => import('../component/page/sideeffect/EffectSummary.vue');
// const PageAiDoctor = () => import('../component/page/search/AiDoctor.vue');
// const PageFooterDonate = () => import('../component/page/footer/Donate.vue');
const Page404 = () => import('../component/page/info/Error404.vue');
const PageUpgrade = () => import('../component/page/info/Upgrade.vue');
const PageVerify = () => import('../component/page/info/Verify.vue');
const PageLineBundle = () => import('../component/page/info/LineBundle.vue');
const PageFeedback = () => import('../component/page/info/Feedback.vue');
const PageResetPassword = () => import('../component/page/info/ResetPassword.vue');
const PagePaymentFailed = () => import('../component/page/info/PaymentFailed.vue');
const PagePaymentSuccess = () => import('../component/page/info/PaymentSuccess.vue');
const PagePaymentConvert = () => import('../component/page/info/PaymentConvert.vue');
const PagePaymentExist = () => import('../component/page/info/PaymentExist.vue');
const PagePaymentExpire = () => import('../component/page/info/PaymentExpire.vue');
const PageUnsubscribe = () => import('../component/page/info/Unsubscribe.vue');
// const PageRank = () => import('../component/page/rank/Rank.vue');
const PageShop = () => import('../component/page/shop/Shop.vue');
// const PageNewPost = () => import('../component/page/account/Post.vue');
// const PageRedeem = () => import('../component/page/shop/Redeem.vue');
// const PageShopStuffDetail = () => import('../component/page/shop/ShopProductStuffDetail.vue');
// const PageShopBundleDetail = () => import('../component/page/shop/ShopProductBundleDetail.vue');
// const PageShopSubscribeDetail = () => import('../component/page/shop/ShopProductSubscribeDetail.vue');
const PageOrders = () => import('../component/page/account/Order.vue');
const PageLineAuthorize = () => import('../component/page/member/LineAuthorize.vue');
const PageBinder = () => import('../component/page/member/Binder.vue');

Vue.use(VueRouter);

// const checkLoginStatusRedirect = (to, from, next) => {
//   // console.log('checkLoginStatusRedirect', store.getters['user/exportLoginStatus']);
//   if (!store.getters['user/exportLoginStatus']) {
//     next();
//     return;
//   }
//   next('/sideeffect/record');
// };

export default new VueRouter({
  // base: ENV_MODE,
  base: '/',
  // base: process.env.BASE_URL,
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: PageIndex,
      props: (route) => ({
        query: route.query.v,
      }),
      // beforeEnter: checkLoginStatusRedirect,
    },
    // {
    //   path: '/:type(scoop|resume|qa)',
    //   name: 'feature-type',
    //   component: PageFeature,
    //   props: true,
    // },
    {
      path: '/register',
      name: 'register',
      component: PageRegister,
      props: (route) => ({
        query: {
          t: route.query.t,
        },
      }),
    },
    {
      path: '/line/authorize',
      name: 'line-authorize',
      component: PageLineAuthorize,
    },
    {
      path: '/binder',
      name: 'binder',
      component: PageBinder,
    },
    // {
    //   path: '/select/tags',
    //   name: 'select-tags',
    //   component: PageSelectTag,
    //   props: true,
    // },
    {
      path: '/setting',
      name: 'setting',
      component: PageSetting,
    },
    {
      path: '/ecard',
      name: 'ecard',
      component: PageEcard,
    },
    // {
    //   path: '/post',
    //   name: 'post',
    //   component: PageNewPost,
    // },
    {
      path: '/events',
      name: 'events',
      component: PageEvent,
    },
    {
      path: '/events/ev:date',
      name: 'events-block',
      component: PageEventBlock,
      props: true,
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: PageFeedback,
    },
    {
      path: '/reset_password/:uid/:token',
      name: 'resetPassword',
      component: PageResetPassword,
      props: true,
    },
    // {
    //   path: '/help',
    //   name: 'help',
    //   component: PageHelp,
    //   props: (route) => ({
    //     query: {
    //       f: route.query.f,
    //       l: route.query.l,
    //       t: route.query.t,
    //     },
    //   }),
    // },
    // {
    //   path: '/sideeffect/demo',
    //   name: 'effect-demo',
    //   component: PageSideEffectDemo,
    // },
    {
      path: '/sideeffect/setup',
      name: 'effect-setup',
      component: PageSideEffectSetup,
      props: (route) => ({
        query: route.query.b,
      }),
    },
    {
      path: '/sideeffect',
      // name: 'effect',
      component: PageSideEffect,
      children: [
        {
          path: '',
          name: 'effect-user',
          component: PageSideEffectBoard,
          redirect: { name: 'effect-record' },
          // props: (route) => ({
          //   query: route.query.f,
          // }),
          children: [
            {
              path: 'record',
              name: 'effect-record',
              component: PageSideEffectRecord,
              props: (route) => ({
                query: route.query.r,
              }),
            },
            {
              path: 'summary',
              name: 'effect-summary',
              component: PageSideEffectRecord,
            },
            {
              path: 'translator',
              name: 'effect-translator',
              component: PageSideEffectTranslator,
            },
            {
              path: 'consult',
              name: 'effect-consult',
              component: PageSideEffectConsult,
              props: (route) => ({
                // query: route.query.v,
                query: {
                  v: route.query.v,
                  c: route.query.c,
                },
              }),
            },
            {
              path: 'diet',
              name: 'effect-diet',
              component: PageSideEffectDiet,
            },
            {
              path: 'blood',
              name: 'chronic-blood',
              component: PageSideChronicBlood,
            },
          ],
        },
      ],
    },
    {
      path: '/sideeffect/post',
      name: 'effect-post',
      component: PageSideEffectPost,
    },
    {
      path: '/sideeffect/post/:id-:hash',
      name: 'effect-post-generator',
      component: PageSideEffectPostGenerator,
      // props: (route) => ({
      //   query: route.query.f,
      // }),
    },
    // {
    //   path: '/aidoctor',
    //   name: 'ai-doctor',
    //   component: PageAiDoctor,
    //   props: (route) => ({
    //     query: route.query.q,
    //   }),
    // },
    // {
    //   path: '/:type(normal|doctor)/:id',
    //   name: 'profile',
    //   component: PageProfile,
    //   redirect: { name: 'profile-detail' },
    //   children: [
    //     {
    //       path: '',
    //       name: 'profile-detail',
    //       component: PageProfileDetail,
    //       props: true,
    //     },
    //     // {
    //     //   path: 'bookmark',
    //     //   name: 'profile-bookmark',
    //     //   component: PageProfileBookmark,
    //     //   props: true,
    //     // },
    //     // {
    //     //   path: 'resume',
    //     //   name: 'profile-resume',
    //     //   component: PageProfileResume,
    //     //   props: true,
    //     // },
    //     // {
    //     //   path: 'follower',
    //     //   name: 'profile-follower',
    //     //   component: PageProfileFollower,
    //     //   props: true,
    //     // },
    //     // {
    //     //   path: 'following',
    //     //   name: 'profile-following',
    //     //   component: PageProfileFollowing,
    //     //   props: true,
    //     // },
    //     // {
    //     //   path: 'record',
    //     //   name: 'profile-record',
    //     //   component: PageProfileQaRecord,
    //     //   props: true,
    //     // },
    //   ],
    // },
    // {
    //   path: '/qa/:quesId',
    //   name: 'qa-detail',
    //   component: PageQaDetail,
    //   props: true,
    // },
    // {
    //   path: '/scoop/:scoopId',
    //   name: 'scoop-detail',
    //   component: PageScoopDetail,
    //   props: true,
    // },
    {
      path: '/course',
      name: 'course-menu',
      component: PageCourseMenu,
      props: (route) => ({
        query: route.query.f,
      }),
    },
    {
      path: '/course/:courseId',
      name: 'course',
      component: PageCourse,
      props: (route) => ({
        params: {
          courseId: route.params.courseId,
        },
        query: route.query.u,
      }),
    },
    // {
    //   path: '/team/:teamId',
    //   name: 'team-detail',
    //   component: PageTeamDetail,
    //   props: true,
    // },
    // {
    //   path: '/search/:searchType/:keyword',
    //   name: 'search-result',
    //   component: PageSearchResult,
    //   props: true,
    // },
    {
      path: '/about',
      name: 'footer-about',
      component: PageFooterAbout,
    },
    // {
    //   path: '/tutorial',
    //   name: 'footer-tutorial',
    //   component: PageFooterTutorial,
    // },
    {
      path: '/privacy',
      name: 'footer-privacy',
      component: PageFooterPrivacy,
    },
    {
      path: '/term',
      name: 'footer-termUsage',
      component: PageFooterTermUsage,
    },
    // {
    //   path: '/donate',
    //   name: 'footer-donate',
    //   component: PageFooterDonate,
    // },
    {
      path: '/404',
      name: 'error404',
      component: Page404,
    },
    {
      path: '/upgrade',
      name: 'upgrade',
      component: PageUpgrade,
    },
    {
      path: '/verify',
      name: 'verify',
      component: PageVerify,
    },
    {
      path: '/line/bundle',
      name: 'line-bundle',
      component: PageLineBundle,
      props: (route) => ({
        query: route.query.l,
      }),
    },
    {
      path: '/payment/success',
      name: 'payment-success',
      component: PagePaymentSuccess,
    },
    {
      path: '/payment/convert',
      name: 'payment-convert',
      component: PagePaymentConvert,
    },
    {
      path: '/payment/failed',
      name: 'payment-failed',
      component: PagePaymentFailed,
    },
    {
      path: '/payment/exist',
      name: 'payment-exist',
      component: PagePaymentExist,
    },
    {
      path: '/payment/expire',
      name: 'payment-expire',
      component: PagePaymentExpire,
    },
    {
      path: '/unsubscribe',
      name: 'unsubscribe',
      component: PageUnsubscribe,
      // props: (route) => ({
      //   query: route.query.m,
      // }),
    },
    // {
    //   path: '/rank',
    //   name: 'rank',
    //   component: PageRank,
    // },
    // {
    //   path: '/redeem',
    //   name: 'redeem',
    //   component: PageRedeem,
    // },
    {
      path: '/shop/:type(subscribe|business)',
      name: 'shop',
      component: PageShop,
      props: true,
    },
    // {
    //   path: '/shop/stuff/:sid',
    //   name: 'shop-stuff',
    //   component: PageShopStuffDetail,
    //   props: true,
    // },
    // {
    //   path: '/shop/bundle/:id',
    //   name: 'shop-bundle',
    //   component: PageShopBundleDetail,
    // },
    // {
    //   path: '/shop/subscribe/:sid',
    //   name: 'shop-subscribe',
    //   component: PageShopSubscribeDetail,
    //   props: true,
    // },
    {
      path: '/orders',
      name: 'orders',
      component: PageOrders,
    },
    {
      path: '*',
      redirect: { name: 'error404' },
    },
  ],

  scrollBehavior(to, from, savedPosition) {
    let returnValue;

    if (savedPosition) {
      returnValue = savedPosition;
    }

    if (to.hash) {
      returnValue = {
        selector: to.hash,
        offset: { x: 0, y: 100 },
      };
    }

    if (to.name !== 'effect-record') {
      returnValue = { x: 0, y: 0 };
    }

    return returnValue;
  },
});
